// removed by extract-text-webpack-plugin
module.exports = {"bg-white":"app-pages-Library-Item-ItemDetail-ItemForm-COGS-COGSFieldArray-COGSField-__COGSField___3hwbL","rp-cogs":"app-pages-Library-Item-ItemDetail-ItemForm-COGS-COGSFieldArray-COGSField-__COGSField___3QMZ6","rp-cogs-error":"app-pages-Library-Item-ItemDetail-ItemForm-COGS-COGSFieldArray-COGSField-__COGSField___shQ9P","input-cogs":"app-pages-Library-Item-ItemDetail-ItemForm-COGS-COGSFieldArray-COGSField-__COGSField___2b-gi"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Library/Item/ItemDetail/ItemForm/COGS/COGSFieldArray/COGSField/COGSField.css
// module id = 2169
// module chunks = 0